import { render, staticRenderFns } from "./SetupRelationProductOperationMode.vue?vue&type=template&id=4c7af1ac"
import script from "./SetupRelationProductOperationMode.vue?vue&type=script&lang=js"
export * from "./SetupRelationProductOperationMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports